export const FormAccountsToggle = ({ enabled, canEdit, onChange }) => (
  <div
    className={`rounded-xl border p-4 ${enabled ? "bg-violet-50/50 border-violet-200" : "bg-slate-50 border-slate-300"}`}
    data-testid="form-accounts-section"
  >
    <label className={`flex items-start gap-3 ${canEdit ? "cursor-pointer" : "cursor-not-allowed opacity-80"}`}>
      <input
        type="checkbox"
        checked={enabled}
        disabled={!canEdit}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 w-4 h-4 accent-violet-600"
        data-testid="form-accounts-toggle"
      />
      <div>
        <div className="font-semibold text-slate-900 text-sm inline-flex items-center gap-2 flex-wrap">
          Record in Accounts dashboard
          <span
            className={`text-[9px] font-bold px-1.5 py-0.5 rounded-full uppercase border ${enabled ? "bg-emerald-100 text-emerald-800 border-emerald-200" : "bg-rose-100 text-rose-700 border-rose-200"}`}
            data-testid="form-accounts-status"
          >
            {enabled ? "On" : "Off"}
          </span>
          {!canEdit && (
            <span className="text-[9px] font-bold bg-amber-100 text-amber-800 border border-amber-200 px-1.5 py-0.5 rounded-full uppercase">Admin only</span>
          )}
        </div>
        <div className="text-xs text-slate-500 mt-1">
          When on, every paid submission creates a receipt, updates the school account and posts a journal entry.
          When off, payments are still collected but <b>no receipt, school ledger or journal entry</b> is created and
          <b> no receipt email</b> is sent. Past entries stay as they are, and submissions made while off are not added later.
        </div>
      </div>
    </label>
  </div>
);
